import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Public pages
import LandingPage from "@/pages/LandingPage";
import LoadPostingPortal from "@/pages/LoadPostingPortal";
import DriverLoadBoard from "@/pages/DriverLoadBoard";
import DriverDashboard from "@/pages/DriverDashboard";
import DriverSignup from "@/pages/DriverSignup";
import LoadAlertsPage from "@/pages/LoadAlertsPage";
import TrackingPage from "@/pages/TrackingPage";
import DriverTrackingPage from "@/pages/DriverTrackingPage";
import PaymentResultPage from "@/pages/PaymentResultPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import AIDispatcherPage from "@/pages/AIDispatcherPage";
import QuickPayPage from "@/pages/QuickPayPage";
import RatePredictorPage from "@/pages/RatePredictorPage";
import FactoringMarketplace from "@/pages/FactoringMarketplace";
import FuelCardPage from "@/pages/FuelCardPage";
import VoiceAgentPage from "@/pages/VoiceAgentPage";

// Admin pages
import AdminLogin from "@/pages/AdminLogin";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import LoadsPage from "@/pages/LoadsPage";
import FleetPage from "@/pages/FleetPage";
import DispatchPage from "@/pages/DispatchPage";
import BrokersPage from "@/pages/BrokersPage";
import InvoicesPage from "@/pages/InvoicesPage";
import EmailOutreachPage from "@/pages/EmailOutreachPage";
import ContractsPage from "@/pages/ContractsPage";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";
import MessagingCenter from "@/pages/MessagingCenter";
import EmailAssistant from "@/pages/EmailAssistant";
import LoadPipeline from "@/pages/LoadPipeline";
import LoadNegotiator from "@/pages/LoadNegotiator";
import ReferralProgram from "@/pages/ReferralProgram";
import DocumentsPage from "@/pages/DocumentsPage";
import PremiumFeaturesPage from "@/pages/PremiumFeaturesPage";
import CommandCenter from "@/pages/CommandCenter";
import AutomationHub from "@/pages/AutomationHub";
import AIDispatcherAdmin from "@/pages/AIDispatcherAdmin";
import CampaignsPage from "@/pages/CampaignsPage";
import ProposalPipelinePage from "@/pages/ProposalPipelinePage";
import AdminLoadsPage from "@/pages/AdminLoadsPage";
import AutopilotPage from "@/pages/AutopilotPage";
import RevenueCommandCenter from "@/pages/RevenueCommandCenter";
import LaneIntelligencePage from "@/pages/LaneIntelligencePage";
import PricingPage from "@/pages/PricingPage";
import InvoicePayPage from "@/pages/InvoicePayPage";
import DriverTrustPage from "@/pages/DriverTrustPage";
import SoloCommandCenter from "@/pages/SoloCommandCenter";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CarrierOnboardingPage from "@/pages/CarrierOnboardingPage";
import CarrierCompliancePage from "@/pages/CarrierCompliancePage";
import SetupStatusPage from "@/pages/SetupStatusPage";
import EnterpriseProposalPage from "@/pages/EnterpriseProposalPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* PUBLIC ROUTES - Anyone can access */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/post-load" element={<LoadPostingPortal />} />
          <Route path="/loads" element={<DriverLoadBoard />} />
          <Route path="/load-board" element={<DriverLoadBoard />} />
          <Route path="/driver" element={<DriverDashboard />} />
          <Route path="/driver-signup" element={<DriverSignup />} />
          <Route path="/alerts" element={<LoadAlertsPage />} />
          <Route path="/load-alerts" element={<LoadAlertsPage />} />
          
          {/* TRACKING PAGES */}
          <Route path="/track/:token" element={<TrackingPage />} />
          <Route path="/driver/track/:token" element={<DriverTrackingPage />} />
          
          {/* PAYMENT PAGES */}
          <Route path="/payment/success" element={<PaymentResultPage />} />
          <Route path="/payment/cancel" element={<PaymentResultPage />} />
          
          {/* UNSUBSCRIBE PAGE */}
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          
          {/* AI DISPATCHER PAGE */}
          <Route path="/ai-dispatcher" element={<AIDispatcherPage />} />
          
          {/* QUICK PAY PAGE */}
          <Route path="/quickpay" element={<QuickPayPage />} />
          <Route path="/quick-pay" element={<QuickPayPage />} />
          
          {/* RATE PREDICTOR PAGE */}
          <Route path="/rate-predictor" element={<RatePredictorPage />} />
          <Route path="/rates" element={<RatePredictorPage />} />
          
          {/* FACTORING MARKETPLACE PAGE */}
          <Route path="/factoring" element={<FactoringMarketplace />} />
          <Route path="/invoice-factoring" element={<FactoringMarketplace />} />
          
          {/* FUEL CARD PAGE */}
          <Route path="/fuel-card" element={<FuelCardPage />} />
          <Route path="/fuelcard" element={<FuelCardPage />} />
          
          {/* VOICE AGENT PAGE */}
          <Route path="/voice-agent" element={<VoiceAgentPage />} />
          <Route path="/voice" element={<VoiceAgentPage />} />
          
          {/* ADMIN LOGIN */}
          <Route path="/admin" element={<AdminLogin />} />
          
          {/* PROTECTED ADMIN ROUTES - Login required */}
          <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute><AnalyticsDashboard /></ProtectedRoute>} />
          <Route path="/admin/loads" element={<ProtectedRoute><AdminLoadsPage /></ProtectedRoute>} />
          <Route path="/admin/loads-legacy" element={<ProtectedRoute><LoadsPage /></ProtectedRoute>} />
          <Route path="/admin/fleet" element={<ProtectedRoute><FleetPage /></ProtectedRoute>} />
          <Route path="/admin/brokers" element={<ProtectedRoute><BrokersPage /></ProtectedRoute>} />
          <Route path="/admin/messaging" element={<ProtectedRoute><MessagingCenter /></ProtectedRoute>} />
          <Route path="/admin/email-assistant" element={<ProtectedRoute><EmailAssistant /></ProtectedRoute>} />
          <Route path="/admin/pipeline" element={<ProtectedRoute><LoadPipeline /></ProtectedRoute>} />
          <Route path="/admin/load-pipeline" element={<ProtectedRoute><LoadPipeline /></ProtectedRoute>} />
          <Route path="/admin/negotiator" element={<ProtectedRoute><LoadNegotiator /></ProtectedRoute>} />
          <Route path="/admin/outreach" element={<ProtectedRoute><EmailOutreachPage /></ProtectedRoute>} />
          <Route path="/admin/invoices" element={<ProtectedRoute><InvoicesPage /></ProtectedRoute>} />
          <Route path="/admin/contracts" element={<ProtectedRoute><ContractsPage /></ProtectedRoute>} />
          <Route path="/admin/dispatch" element={<ProtectedRoute><DispatchPage /></ProtectedRoute>} />
          <Route path="/admin/referrals" element={<ProtectedRoute><ReferralProgram /></ProtectedRoute>} />
          <Route path="/admin/documents" element={<ProtectedRoute><DocumentsPage /></ProtectedRoute>} />
          <Route path="/admin/premium" element={<ProtectedRoute><PremiumFeaturesPage /></ProtectedRoute>} />
          <Route path="/admin/command" element={<ProtectedRoute><CommandCenter /></ProtectedRoute>} />
          <Route path="/admin/automation" element={<ProtectedRoute><AutomationHub /></ProtectedRoute>} />
          <Route path="/admin/ai-dispatcher" element={<ProtectedRoute><AIDispatcherAdmin /></ProtectedRoute>} />
          <Route path="/admin/autopilot" element={<ProtectedRoute><AutopilotPage /></ProtectedRoute>} />
          <Route path="/admin/revenue" element={<ProtectedRoute><RevenueCommandCenter /></ProtectedRoute>} />
          <Route path="/admin/lane-intelligence" element={<ProtectedRoute><LaneIntelligencePage /></ProtectedRoute>} />
          <Route path="/admin/solo" element={<ProtectedRoute><SoloCommandCenter /></ProtectedRoute>} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/subscription/success" element={<PricingPage />} />
          <Route path="/subscription/cancel" element={<PricingPage />} />
          <Route path="/invoice/:id" element={<InvoicePayPage />} />
          <Route path="/admin/driver-trust" element={<ProtectedRoute><DriverTrustPage /></ProtectedRoute>} />
          <Route path="/admin/carrier-compliance" element={<ProtectedRoute><CarrierCompliancePage /></ProtectedRoute>} />
          <Route path="/admin/setup-status" element={<ProtectedRoute><SetupStatusPage /></ProtectedRoute>} />
          <Route path="/admin/enterprise/proposal" element={<ProtectedRoute><EnterpriseProposalPage /></ProtectedRoute>} />
          <Route path="/enterprise/proposal" element={<ProtectedRoute><EnterpriseProposalPage /></ProtectedRoute>} />
          <Route path="/admin/campaigns" element={<ProtectedRoute><CampaignsPage /></ProtectedRoute>} />
          <Route path="/admin/proposals" element={<ProtectedRoute><ProposalPipelinePage /></ProtectedRoute>} />
          <Route path="/carrier/onboarding/:token" element={<CarrierOnboardingPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
